<!-- 新闻资讯 -->
<template>
	<div class="markdown-body" style="padding-left: 20px;padding-right: 20px;">
	<div style="text-align: center;">
		<p><strong>有道移动广告SDK隐私政策</strong></p>
	</div>
	<p>更新日期：2023年12月5日</p>
	<p>生效日期：2023年12月5日</p>
	<p><strong>有道移动广告SDK（以下简称“本SDK”“本产品”或“本SDK产品”）是由北京网易有道计算机系统有限公司（以下简称“有道”或“我们”）提供的软件开发工具包（SDK），开发者可将本SDK集成到其自行开发的产品或服务中并向最终用户提供，最终用户相关的个人信息将被开发者共享给有道并按照《有道移动广告SDK隐私政策》（以下简称“本政策”）进行处理。</strong>
	</p>
	<p><a id="OLE_LINK4"></a><strong>本政策旨在向开发者及最终用户告知，为了实现有道移动广告SDK的相关功能，本SDK
		收集、使用和处理最终用户个人信息的情况。请开发者及最终用户认真阅读本政策，在您确认充分理解并同意后再开始使用。如您在阅读后继续使用本SDK，即意味着您同意本政策并同意我们按照本政策处理您或您的用户的相关个人信息。</strong>
	</p>
	<p><strong>【特别提示】</strong></p>
	<p><strong>1.如您是开发者，您应当：</strong></p>
	<p><strong>（1）在遵守适用法律、法规、部门规章、规范性文件的前提下收集、使用和处理最终用户的个人信息，包括但不限于《网络安全法》《数据安全法》《个人信息保护法》《未成年人个人信息网络保护规定》《App违法违规收集使用个人信息行为认定方法》《信息安全技术
		个人信息安全规范（GB/T 35273-2020）》等。</strong></p>
	<p><strong>（2）告知最终用户其使用的产品或服务中使用了本SDK，以及本SDK 收集、使用和处理最终用户信息的方式，同时应于产品或服务的隐私政策中提供超链接跳转至本政策，以便最终用户在授权前充分了解。</strong></p>
	<p><strong>（3）依法获得最终用户对于本SDK处理最终用户相关个人信息的授权同意。如开发者开发的产品或服务的最终用户是未成年人，开发者应已依法获得最终用户的父母或其他监护人的授权同意。</strong></p>
	<p><strong>（4）向最终用户提供易于操作的用户权利实现机制，包括告知最终用户如何行使其知情、查阅、复制、更正、删除、撤回授权、注销账号等相关法律法规规定的各项用户权利。</strong></p>
	<p><strong>（5）已阅读理解并同意本政策的内容，遵守相关要求。</strong></p>
	<p><strong>请您确认充分了解并同意本政策后再集成 SDK 产品，如果您不同意本政策及按照本政策履行对应的用户个人信息保护义务，应立即停止接入及使用 本SDK
		产品；同时，您应仅在征得最终用户的同意后再集成本SDK并处理最终用户的个人信息，在未获得最终用户同意前不得使用本SDK。</strong></p>
	<br />
	<p><strong>2.如您是最终用户，您应当：</strong></p>
	<p><strong>（1）认真阅读并理解本政策，了解您的个人信息在使用本SDK服务时会被如何收集、使用、处理并决定是否授权同意。也请您注意，本政策仅针对本SDK对您的个人信息的处理情况，开发者如何收集、使用、处理您的个人信息不受本政策约束，而是受到其自身的个人信息保护声明约束，我们无法控制开发者的产品或服务，亦无法为其产品或服务提供保证或承担责任。</strong>
	</p>
	<p><strong>（2）若您是未成年人，请通知您的父母或其他监护人共同阅读本政策，并在您使用语音评测SDK服务前，获取您的父母或其他监护人的同意。若您是未成年人的父母或其他监护人且您监护的未成年人需要使用我们的语音评测SDK服务，在未成年人使用前，请您仔细阅读本政策，并在确认充分理解并同意全部条款后再允许您监护的未成年人使用。</strong>
	</p>
	<br />
	<p>在阅读完本政策后，如您对本政策或与本政策相关的事宜有任何问题，您可通过本政策“如何联系我们”章节所列的反馈渠道联系我们，我们会尽快为您作出解答。</p>
	<p><strong>本政策将帮助您了解以下内容</strong></p>
	<p><a href="http://shared.youdao.com/dict/market/youdaoInc-v2.1/index.html"><strong>一、我们如何收集和使用个人信息</strong></a></p>
	<p><a href="http://shared.youdao.com/dict/market/youdaoInc-v2.1/index.html"><strong>二、我们如何共享、转让和披露个人信息</strong></a></p>
	<p><a href="http://shared.youdao.com/dict/market/youdaoInc-v2.1/index.html"><strong>三、我们如何储存和保护您的个人信息安全</strong></a></p>
	<p><a href="http://shared.youdao.com/dict/market/youdaoInc-v2.1/index.html"><strong>四、如何管理您的个人信息</strong></a></p>
	<p><a href="http://shared.youdao.com/dict/market/youdaoInc-v2.1/index.html"><strong>五、未成年人保护</strong></a></p>
	<p><a href="http://shared.youdao.com/dict/market/youdaoInc-v2.1/index.html"><strong>六、通知和修订</strong></a></p>
	<p><a href="http://shared.youdao.com/dict/market/youdaoInc-v2.1/index.html"><strong>七、如何联系我们</strong></a></p>
	<p><strong>八、法律适用与管辖</strong></p>
	<p> </p>
	<p><strong>一、我们如何收集和使用个人信息</strong></p>
	<p><strong>1. 为实现本SDK产品功能所需收集的个人信息</strong></p>
	<p>为实现 SDK 产品的相应功能所必须，我们将向最终用户或开发者收集最终用户在使用与 SDK 产品相关的功能时产生的如下个人信息并申请以下所需权限：</p>
	<table>
		<tr>
			<td><p>个人信息类型及设备权限</p></td>
			<td><p>个人信息内容</p></td>
			<td><p>处理目的</p></td>
		</tr>
		<tr>
			<td><p><strong>设备信息和标识符</strong></p></td>
			<td><p>必选信息：</p>
				<p><strong>设备名称、</strong>唯一设备识别码（如IMEI/OAID/Android
					ID/IDFA/OPENUDID/GUID、SIM卡序列号、SIM卡IMSI信息等在内的描述个人常用设备基本情况的信息）、WIFI BSSID、WIFI
					SSID、设备型号、设备MAC地址、操作系统类型、设备设置、运行中进程信息、硬件序列号、应用程序版本、语言设置、分辨率、服务提供商网络ID（PLMN）、网络标识信息（个人信息主体账号、IP地址、网络类型、个人数字证书）。
				</p></td>
			<td><p>广告投放及广告监测归因、反作弊</p></td>
		</tr>
		<tr>
			<td><p>传感器信息</p></td>
			<td><p>必选信息：</p>
				<p>【Android】加速度传感器、陀螺仪传感器、线性加速度传感器、磁场传感器、旋转矢量传感器</p>
				<p>【iOS】加速度传感器、陀螺仪传感器</p></td>
			<td><p>摇一摇、扭一扭等广告投放、广告反作弊</p></td>
		</tr>
		<tr>
			<td><p>广告信息</p></td>
			<td><p>必选信息：</p>
				<p>【Android、iOS】对广告的展示、点击及转化等交互数据</p></td>
			<td><p>广告监测归因、广告投放统计分析、反作弊</p></td>
		</tr>
		<tr>
			<td><p>位置信息</p></td>
			<td><p>可选信息：【Android、iOS】精确位置信息、粗略位置信息</p></td>
			<td><p>广告定向投放及反作弊</p></td>
		</tr>
		<tr>
			<td><p>应用信息</p></td>
			<td><p>必选信息：【Android】应用包名、运行中的进程信息、版本号、应用前后台状态</p>
				<p>可选信息：【Android】软件列表信息</p></td>
			<td><p>广告投放、反作弊</p></td>
		</tr>
		<tr>
			<td><p>性能数据</p></td>
			<td><p>必选信息：【Android、iOS】如崩溃数据、性能数据</p></td>
			<td><p>减少App崩溃、提供稳定可靠的服务</p></td>
		</tr>
	</table>
	<p>
		请注意，基于不同的设备和系统，权限显示方式及关闭方式会有所不同，需同时参考最终用户使用的设备及操作系统开发方的说明或指引。请您注意，您开启任一权限即代表您授权我们可以收集和使用相关信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关信息，也无法为您提供该权限所对应的服务。但是，您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。</p>

	<br />
	<p><strong>2. 提供个性化推荐服务</strong></p>
	<p>
		为了展示、推荐相关性更高的信息，提供更契合您的服务，有道移动广告SDK会收集、使用您的个人信息并通过计算机算法模型自动计算、预测您的偏好，以匹配您可能感兴趣的信息或服务，以下我们将详细说明该个性化推荐服务的运行机制以及您实现控制的方式。</p>
	<p>（1) 个性化推荐服务的适用范围：我们提供个性化推荐服务的范围包括但不限于投放广告，展示图文或视频/直播内容，推荐商品或者服务。</p>
	<p>（2) 个性化推荐服务收集的字段：为了提供个性化的服务，我们可能会收集、使用您的设备信息（包括硬件型号、操作系统版本、设备标识符（IMEI、IMSI、MAC地址、OAID、MEID、Android
		ID、IDFA、IDFV）、您的操作信息（包括广告浏览、点击、转化等相关操作记录）、应用程序的总体安装使用情况以及经您授权由其他合作方提供的其他信息。系统会对上述信息进行自动分析和计算，预测您的偏好特征，根据计算结果提供个性化推荐广告和服务。</p>
	<p>（3)
		个性化推荐服务的训练和干预：我们会根据您在使用过程中的浏览相关行为对推荐模型进行实时训练和反馈，不断调整优化推荐结果。为了满足您的多元需求，避免同类型内容过于集中，我们会综合运用多样化技术对内容进行自动化处理，更好地提供优质内容和服务。</p>
	<p>请您理解，由于我们与您并无直接交互对话界面，如您希望退出个性化广告推荐功能，您可以在开发者应用内关闭。我们已向开发者提供退出个性化广告推荐服务的接口，并要求开发者确保在您选择关闭时调用该接口，以确保个性化广告推荐服务真实退出。</p>
	<p>请开发者注意，如果您向最终用户提供有道移动广告SDK提供的个性化广告推荐功能，您应在APP隐私政策中向最终用户告知相应的功能，详细查阅<a
		href="https://zhixuan.163.com/developer/helpCenter/sdkDownload">《有道移动广告SDK合规使用说明文档》</a>并根据我们提供配置方式进行相应配置，确保在最终用户选择关闭个性化广告推荐功能时调用相关接口，停止向最终用户继续提供个性化推荐广告。
	</p>
	<br />

	<p><strong>3. 其他用途</strong></p>
	<p>我们可能会对您提供或我们收集的信息进行去标识化地研究、统计分析和预测，用于改善和提升有道SDK的服务，为营销决策提供产品或技术服务支撑。</p>
	<p>我们还可能为了履行服务内容而收集您的其他信息，例如您与我们的客户服务团队联系时提供的相关信息。</p>

	<br />
	<p><strong>4.征得授权同意的例外</strong></p>
	<p>根据相关法律法规规定，以下情形中收集您的个人信息无需征得您的授权同意：</p>
	<p>（1）为订立、履行与最终用户的合同所必需；</p>
	<p>（2）为履行我们的法定职责或法定义务所必需；</p>
	<p>（3）为应对突发公共卫生事件，或者紧急情况下为保护最终用户的生命健康和财产安全所必需；</p>
	<p>（4）为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；</p>
	<p>（5）依照本法规定在合理的范围内处理最终用户自行公开或者其他已经合法公开的个人信息；</p>
	<p>（6）法律行政法规规定的其他情形。 </p>
	<p><strong>请注意，如我们收集的信息无法单独或结合其他信息识别到特定自然人的个人身份（例如单独的设备信息、日志信息），其不属于法律意义上的个人信息。 </strong></p>

	<br />
	<p><strong>二、我们如何共享、转让和披露个人信息</strong></p>
	<p><strong>1.共享</strong></p>
	<p>我们非常重视保护您的个人信息。除以下情形外，我们不会与我们及我们的关联方之外的任何第三方分享您的个人信息：</p>
	<p>（1）在获取明确同意的情况下共享：获得最终用户的明确同意后，我们会与第三方共享最终用户的个人信息。</p>
	<p>（2）<strong>与我们的部分合作伙伴的必要共享</strong>。我们可能与委托我们进行推广和广告投放的合作伙伴和其他合作伙伴如广告主、代理商、广告监测服务商、进行广告投放与优化合作的关联方等（合称“广告合作方”）共享分析去标识化或匿名化处理的设备信息、统计信息、标签信息或其他由有道移动广告SDK所采集的必要信息。这些信息难以或无法与您的真实身份相关联。这些信息将帮助我们分析、衡量、优化广告和相关服务的有效性，提升广告有效触达率。具体如下：
	</p>
	<p>a）
		广告推送与投放：进行推送/推广和广告投放或提供相关服务的广告合作方可能需要使用您的设备信息、网络信息、渠道信息以及标签信息；与广告主合作的广告推送/推广、投放/分析服务的广告合作方可能需要使用前述信息，以实现广告投放、优化与提升广告有效触达率。</p>
	<p>b）广告统计分析：提供广告统计分析服务的广告合作方可能需要使用您的设备、网络、广告点击、浏览、展示以及广告转化数据等信息用于分析、衡量、优化广告和相关服务的有效性。</p>
	<p>c）广告合作方对信息的使用：广告合作方可能将上述信息与其合法获取的其他数据相结合，以优化广告投放效果，我们会要求其对信息的使用遵循合法、正当、必要原则，保障您合法权利不受侵犯。</p>
	<p>d）广告留资信息：您在广告中主动填写、提交的联系方式、地址等相关信息，可能被广告主或其委托的合作方收集并使用。</p>
	<p><strong>（3）与我们的关联方的必要共享。为便于我们基于统一的账号体系向您提供一致化服务以及便于您进行统一管理、个性化推荐、保障系统和账号安全等，您的个人信息可能会在我们和我们的关联方之间进行必要共享，包括：1）为了帮助您节省时间、简化操作流程，您在注册手机账号/邮箱账号后无需重复注册即可登录部分单项服务，您的账号相关信息会在我们和我们的关联方的产品内部进行必要共享；2）为了使您在我们的及我们关联方产品与/或服务有一致性和个性化的浏览、广告等服务体验，您知悉并同意，您的账号信息、设备信息、相关浏览数据等反映您使用习惯和爱好的信息可能会与我们的关联方共享。</strong>
	</p>
	<p>
		（4）在法律法规允许的范围内，为了遵守法律、维护我们及我们的关联方或合作伙伴、您或其他有道用户或社会公众利益、财产或安全免遭损害，比如为防止欺诈等违法活动和减少信用风险，我们可能与其他公司和组织交换个人信息。不过,这并不包括违反本政策中所作的承诺而为获利目的出售、出租、共享或以其它方式披露的个人信息。</p>
	<p>（5）应您合法需求，协助处理您与他人的纠纷或争议；</p>
	<p>（6）应您的监护人合法要求而提供您的个人信息；</p>
	<p>（7）根据与您签署的单项服务协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；</p>
	<p>（8）基于学术研究而提供；</p>
	<p>（9）基于符合法律法规的社会公共利益而提供。</p>
	<p>
		<strong>我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息。对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本政策以及其他任何相关的保密和安全措施来处理个人信息。</strong>
	</p>

	<br />
	<p><strong>2.转让</strong></p>
	<p>我们不会将最终用户的个人信息转让给任何第三方，但以下情况除外：</p>
	<ol>
		<li>事先告知并获得最终用户明确同意的情况下转让；</li>
		<li>根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况下进行转让；</li>
		<li>因合并、分立、收购、解散、资产转让或宣告破产等原因，涉及个人信息转让的，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则，我们将要求该公司、组织重新向您征求授权同意。</li>
	</ol>

	<br />
	<p><strong>3.披露</strong></p>
	<p>我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会披露您的个人信息：</p>
	<p>（1）根据您的需求，在您明确同意的披露方式下披露您所指定的个人信息;</p>
	<p>
		（2）根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露个人信息的请求时，我们会要求接收方必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的个人信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。</p>

	<br />
	<p><strong>4.共享、转让、披露个人信息时事先征得授权同意的例外</strong></p>
	<p>以下情形中，共享、转让、披露您的个人信息无需事先征得您的授权同意：</p>
	<p>（1）与个人信息控制者履行法律法规规定的义务相关的；</p>
	<p>（2）与国家安全、国防安全直接相关的；</p>
	<p>（3）与公共安全、公共卫生、重大公共利益直接相关的；</p>
	<p>（4）与刑事侦查、起诉、审判和判决执行等直接相关的；</p>
	<p>（5）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；</p>
	<p>（6）个人信息主体自行向社会公众公开的个人信息；</p>
	<p>（7）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>
	<p>
		<strong>根据法律规定，共享、转让、披露经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</strong>
	</p>

	<br />
	<p><strong>三、我们如何存储和保护您的个人信息</strong></p>
	<p><strong>1.个人信息的存储</strong></p>
	<p><strong>除法律法规或监管部门另有规定外，我们仅在本政策所述目的所必需且最短的时限内存储您的个人信息。</strong>我们仅在本政策所述目的所必需期间和法律法规及监管规定的时限内保存您的个人信息。如我们终止服务或运营，我们将及时停止继续收集您个人信息的活动，同时会遵守相关法律法规要求提前向您通知，并在终止服务或运营后对您的个人信息进行删除或匿名化处理，法律法规或监管部门另有规定的除外。
	</p>
	<p><strong>我们在中华人民共和国境内运营中收集和产生的个人信息，存储在中国境内。以下情形除外：</strong></p>
	<p>（1）法律法规有明确规定；</p>
	<p>（2）获得您的授权同意；</p>
	<p>（3）您使用的本SDK服务涉及跨境，且需要向境外提供您的个人信息的；</p>
	<p>针对以上情形，我们会确保依据本政策及国家法律法规要求对您的个人信息提供足够的保护。</p>

	<br />
	<p><strong>2.个人信息的保护</strong></p>
	<p>我们非常重视个人信息安全，成立了专门的安全团队，并采取一切合理可行的措施，保护您的个人信息：</p>
	<p>（1）数据安全技术措施</p>
	<p>
		我们会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的个人信息遭到未经授权的访问使用、修改,避免数据的损坏或丢失。网络服务采取了多种加密技术，例如在某些服务中，我们将利用加密技术（例如SSL）来保护您的个人信息，采取加密技术对您的个人信息进行加密保存，并通过隔离技术进行隔离。
		在个人信息使用时，例如个人信息展示、个人信息关联计算，我们会采用多种数据脱敏技术增强个人信息在使用中的安全性。采用严格的数据访问权限控制和多重身份认证技术保护个人信息，避免数据被违规使用。</p>
	<p>（2）我们为保护个人信息采取的其他安全措施</p>
	<p>
		（a）我们有行业先进的以数据为核心，围绕数据生命周期进行的数据安全管理体系，从组织建设、制度设计、人员管理、产品技术等方面多维度提升整个系统的安全性。我们通过建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范个人信息的存储和使用。</p>
	<p>（b）我们通过个人信息接触者保密协议、监控和审计机制来对数据进行全面安全控制。</p>
	<p>（c）我们还会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识和安全意识。</p>
	<p>
		（d）我们仅允许有必要知晓这些个人信息的我们及我们关联方的员工、合作伙伴访问您的个人信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您的个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与我们的合作关系。</p>
	<p>（3）互联网并非绝对安全的环境，而且电子邮件、即时通讯、社交软件或其他服务软件等与其他用户的交流方式无法确定是否完全加密，我们建议您使用此类工具时请使用复杂密码，并注意保护您的个人信息安全。</p>
	<p>
		（4）互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何个人信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致个人信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。</p>
	<p>4.安全事件处置</p>
	<p>
		为应对个人信息泄露、损毁和丢失等可能出现的风险，我们制定了多项制度，明确安全事件、安全漏洞的分类分级标准及相应的处理流程。我们也为安全事件建立了的应急响应团队，按照安全事件处置规范要求，针对不同安全事件启动安全预案，进行止损、分析、定位、制定补救措施、联合相关部门进行溯源和打击。我们亦定期组织内部培训和应急演练，使得我们的相关工作人员掌握相应的应急处置策略和规程。</p>
	<p>
		在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们同时将及时将事件相关情况以邮件、信函、短信、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</p>
	<p>请您理解，由于技术的限制以及风险防范的局限，即便我们已经尽量加强安全措施，也无法始终保证个人信息百分之百的安全。您需要了解，您接入本SDK服务所用的系统和通讯网络，有可能因我们可控范围外的情况而发生问题。</p>
	<p>5.安全提示</p>
	<p><strong>尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全，我们将尽力确保您提供给我们的信息的安全性。您知悉并理解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。因此，我们强烈建议您采取积极措施保护用户信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码等信息透露给他人。</strong>
	</p>
	<p><strong>我们谨此特别提醒您，本隐私政策提供的用户信息保护措施仅适用于本服务。一旦您离开本服务相关页面，浏览或使用其他网站、产品、服务及内容资源，我们即没有能力及义务保护您在本服务之外的软件、网站提交的任何信息，无论您登录、浏览或使用上述软件、网站是否基于本服务的链接或引导。</strong>
	</p>

	<br />
	<p><strong>四、如何管理您的个人信息</strong></p>
	<p>我们非常重视您对个人信息管理的权利，包括查阅、复制、更正、补充、删除、撤回授权同意等权利，我们将尽全力帮助您管理您的个人信息，以使您有能力保障自身的隐私和信息安全。</p>
	<p><strong>如您为最终用户，请您知悉：由于您不是我们的直接用户，与我们并无直接的交互对话界面，为保障您的权利实现，我们已要求集成我方服务的开发者承诺，应为您提供便于操作的用户权利实现方式。请您知悉并理解，因开发者独立开发和运营其应用并与您直接发生交互，我们无法控制或全面掌握开发者应用中交互界面设计及其对个人信息权益的响应情况。</strong>
	</p>
	<p>
		<strong>如您为直接面向最终用户提供应用程序服务的开发者，在集成有道移动广告SDK后为最终用户提供服务时：开发者应根据使用的开发者平台提供的功能设置，为最终用户提供并明确其个人信息管理的路径，并及时响应最终用户个人信息管理请求。</strong>
	</p>
	<p>
		在开发者集成使用本服务过程中，如果最终用户提出管理其个人信息的请求，且开发者已确定该等请求涉及到本SDK产品处理的个人信息、需要我们协助处理时，开发者应当及时通过本隐私政策联系方式联系我们，并附上必要的最终用户请求的书面证明材料。我们将及时核验相关材料，并按照相关法律法规及本隐私政策，
		为开发者响应最终用户的行权请求提供相应的支持与配合。</p>

	<br />
	<p><strong>五、未成年人保护</strong></p>
	<p><strong>本SDK产品主要面向成年人。</strong></p>
	<p><strong>如您是开发者，且您产品或服务的最终用户包括未成年人的，开发者应当向不满十四周岁未成年人的监护人详细告知处理未成年人个人信息的情况，并就该等处理事项获得未成年人监护人的授权同意，同时开发者还应当针对不满十四周岁未成年人制定专门的个人信息处理规则。</strong>
	</p>
	<p><strong>若您是未成年人，如您发现存在未经您的授权而收集不满十四周岁未成年人的个人信息，或希望查阅、复制、更正、补充、删除、撤回同意所处理的不满十四周岁未成年人的个人信息，您可以联系SDK所接入的应用开发者，或通过本隐私政策中的联系方式与我们联系，我们将根据法律规定及时进行处理。如我们发现SDK所接入的应用开发者未获得未成年人监护人的授权同意而向我们传输不满十四周岁未成年人的个人信息，我们将主动删除。</strong>
	</p>
	<p><strong>关于我们对未成年人最终用户的保护，您可以通过阅读</strong><a
		href="https://c.youdao.com/dict/law/youdao_agreement/privacy-children.html"><strong>《有道儿童个人信息保护规则及监护人须知》</strong></a><strong>详细了解。</strong>
	</p>

	<br />
	<p><strong>六、通知和修订</strong></p>
	<p><strong>为了给您提供更好的服务，我们可能根据服务的更新情况及法律法规的相关要求适时修改本政策的条款，该等修改构成本政策的一部分。我们会在本页面上公布对本政策所作的任何变更。对于重大变更，我们会提供更显著的通知（包括站内红点提示、网站公告、推送通知、弹窗提示、站内信或其他方式），本政策所指的重大变更包括但不限于：</strong>
	</p>
	<p>1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</p>
	<p>2、我们在所有权结构方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</p>
	<p>3、个人信息共享、转让或公开披露的主要对象发生重大变化；</p>
	<p>4、您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
	<p>5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生重大变化；</p>
	<p>6、其他重要的或可能严重影响您的个人权益的情况发生。</p>
	<p><strong>您如果不同意该等变更，可以选择停止使用本SDK服务；如您仍然继续使用本SDK服务的，即表示同意受经修订的本政策的约束。</strong></p>
	<p>我们的任何修改都会将您的满意度置于首位。我们鼓励您在每次使用本SDK服务时都查阅我们的隐私政策。</p>
	<p>我们可能在必需时（例如当我们由于系统维护而暂停某一项服务时）发出与服务有关的公告。您可能无法取消这些与服务有关、性质不属于推广的公告。最后，您必须对您的账号和密码信息负有保密义务。任何情况下，请小心妥善保管。</p>

	<br />
	<p><strong>七、如何联系我们</strong></p>
	<p>我们设立了个人信息保护专职部门和个人信息保护负责人，如您有关于个人信息安全的投诉和举报，或您对本政策、您的个人信息的相关事宜有任何问题、意见或建议，以及有关本政策或有道隐私措施的问题，请与我们联系：</p>
	<p>（1）登录<a href="https://zhixuan.163.com/">https://zhixuan.163.com/</a> 联系我们；</p>
	<p>（2）邮箱地址：【youdaotest2019@163.com】，或写信至以下地址【北京市海淀区西北旺东路10号院中关村软件园西区7号楼A座2层，<a id="OLE_LINK1"></a>北京网易有道计算机系统有限公司
		个人信息保护负责人（收），邮编：100193】。</p>
	<p>一般情况下，我们将在收到您的问题、意见或建议之日起十五天内予以回复。</p>

	<br />
	<p><strong>八、法律适用与管辖</strong></p>
	<p><strong>本协议适用中华人民共和国的法律（不含冲突法）。当本协议的任何内容与中华人民共和国法律相抵触时，应当以法律规定为准，同时相关内容将按法律规定进行修改或重新解释，而本协议其他部分的法律效力不变。 </strong></p>
	<p><strong>凡因本协议引起的或与本协议有关的任何争议,双方应协商解决。协商不成时，任何一方均可向被告所在地有管辖权的人民法院提起诉讼。</strong></p>
	<br />	<br />
	</div>
</template>

<script>
    export default {
        name: "Sdk",
        data() {
            return {
            }
        },
        mounted() {
        },
    }
</script>

<style scoped>
@media (prefers-color-scheme: dark) {
	.markdown-body {
		color-scheme: dark;
		--color-prettylights-syntax-comment: #8b949e;
		--color-prettylights-syntax-constant: #79c0ff;
		--color-prettylights-syntax-entity: #d2a8ff;
		--color-prettylights-syntax-storage-modifier-import: #c9d1d9;
		--color-prettylights-syntax-entity-tag: #7ee787;
		--color-prettylights-syntax-keyword: #ff7b72;
		--color-prettylights-syntax-string: #a5d6ff;
		--color-prettylights-syntax-variable: #ffa657;
		--color-prettylights-syntax-brackethighlighter-unmatched: #f85149;
		--color-prettylights-syntax-invalid-illegal-text: #f0f6fc;
		--color-prettylights-syntax-invalid-illegal-bg: #8e1519;
		--color-prettylights-syntax-carriage-return-text: #f0f6fc;
		--color-prettylights-syntax-carriage-return-bg: #b62324;
		--color-prettylights-syntax-string-regexp: #7ee787;
		--color-prettylights-syntax-markup-list: #f2cc60;
		--color-prettylights-syntax-markup-heading: #1f6feb;
		--color-prettylights-syntax-markup-italic: #c9d1d9;
		--color-prettylights-syntax-markup-bold: #c9d1d9;
		--color-prettylights-syntax-markup-deleted-text: #ffdcd7;
		--color-prettylights-syntax-markup-deleted-bg: #67060c;
		--color-prettylights-syntax-markup-inserted-text: #aff5b4;
		--color-prettylights-syntax-markup-inserted-bg: #033a16;
		--color-prettylights-syntax-markup-changed-text: #ffdfb6;
		--color-prettylights-syntax-markup-changed-bg: #5a1e02;
		--color-prettylights-syntax-markup-ignored-text: #c9d1d9;
		--color-prettylights-syntax-markup-ignored-bg: #1158c7;
		--color-prettylights-syntax-meta-diff-range: #d2a8ff;
		--color-prettylights-syntax-brackethighlighter-angle: #8b949e;
		--color-prettylights-syntax-sublimelinter-gutter-mark: #484f58;
		--color-prettylights-syntax-constant-other-reference-link: #a5d6ff;
		--color-fg-default: #c9d1d9;
		--color-fg-muted: #8b949e;
		--color-fg-subtle: #6e7681;
		--color-canvas-default: #0d1117;
		--color-canvas-subtle: #161b22;
		--color-border-default: #30363d;
		--color-border-muted: #21262d;
		--color-neutral-muted: rgba(110, 118, 129, 0.4);
		--color-accent-fg: #58a6ff;
		--color-accent-emphasis: #1f6feb;
		--color-attention-subtle: rgba(187, 128, 9, 0.15);
		--color-danger-fg: #f85149
	}
}

@media (prefers-color-scheme: light) {
	.markdown-body {
		color-scheme: light;
		--color-prettylights-syntax-comment: #6e7781;
		--color-prettylights-syntax-constant: #0550ae;
		--color-prettylights-syntax-entity: #8250df;
		--color-prettylights-syntax-storage-modifier-import: #24292f;
		--color-prettylights-syntax-entity-tag: #116329;
		--color-prettylights-syntax-keyword: #cf222e;
		--color-prettylights-syntax-string: #0a3069;
		--color-prettylights-syntax-variable: #953800;
		--color-prettylights-syntax-brackethighlighter-unmatched: #82071e;
		--color-prettylights-syntax-invalid-illegal-text: #f6f8fa;
		--color-prettylights-syntax-invalid-illegal-bg: #82071e;
		--color-prettylights-syntax-carriage-return-text: #f6f8fa;
		--color-prettylights-syntax-carriage-return-bg: #cf222e;
		--color-prettylights-syntax-string-regexp: #116329;
		--color-prettylights-syntax-markup-list: #3b2300;
		--color-prettylights-syntax-markup-heading: #0550ae;
		--color-prettylights-syntax-markup-italic: #24292f;
		--color-prettylights-syntax-markup-bold: #24292f;
		--color-prettylights-syntax-markup-deleted-text: #82071e;
		--color-prettylights-syntax-markup-deleted-bg: #ffebe9;
		--color-prettylights-syntax-markup-inserted-text: #116329;
		--color-prettylights-syntax-markup-inserted-bg: #dafbe1;
		--color-prettylights-syntax-markup-changed-text: #953800;
		--color-prettylights-syntax-markup-changed-bg: #ffd8b5;
		--color-prettylights-syntax-markup-ignored-text: #eaeef2;
		--color-prettylights-syntax-markup-ignored-bg: #0550ae;
		--color-prettylights-syntax-meta-diff-range: #8250df;
		--color-prettylights-syntax-brackethighlighter-angle: #57606a;
		--color-prettylights-syntax-sublimelinter-gutter-mark: #8c959f;
		--color-prettylights-syntax-constant-other-reference-link: #0a3069;
		--color-fg-default: #24292f;
		--color-fg-muted: #57606a;
		--color-fg-subtle: #6e7781;
		--color-canvas-default: #ffffff;
		--color-canvas-subtle: #f6f8fa;
		--color-border-default: #d0d7de;
		--color-border-muted: hsla(210, 18%, 87%, 1);
		--color-neutral-muted: rgba(175, 184, 193, 0.2);
		--color-accent-fg: #0969da;
		--color-accent-emphasis: #0969da;
		--color-attention-subtle: #fff8c5;
		--color-danger-fg: #cf222e
	}
}

.markdown-body {
	-ms-text-size-adjust: 100%;
	-webkit-text-size-adjust: 100%;
	margin: 0;
	color: var(--color-fg-default);
	background-color: var(--color-canvas-default);
	font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Noto Sans", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji";
	font-size: 16px;
	line-height: 1.5;
	word-wrap: break-word
}

.markdown-body .octicon {
	display: inline-block;
	fill: currentColor;
	vertical-align: text-bottom
}

.markdown-body h1:hover .anchor .octicon-link:before, .markdown-body h2:hover .anchor .octicon-link:before, .markdown-body h3:hover .anchor .octicon-link:before, .markdown-body h4:hover .anchor .octicon-link:before, .markdown-body h5:hover .anchor .octicon-link:before, .markdown-body h6:hover .anchor .octicon-link:before {
	width: 16px;
	height: 16px;
	content: ' ';
	display: inline-block;
	background-color: currentColor;
	-webkit-mask-image: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' version='1.1' aria-hidden='true'><path fill-rule='evenodd' d='M7.775 3.275a.75.75 0 001.06 1.06l1.25-1.25a2 2 0 112.83 2.83l-2.5 2.5a2 2 0 01-2.83 0 .75.75 0 00-1.06 1.06 3.5 3.5 0 004.95 0l2.5-2.5a3.5 3.5 0 00-4.95-4.95l-1.25 1.25zm-4.69 9.64a2 2 0 010-2.83l2.5-2.5a2 2 0 012.83 0 .75.75 0 001.06-1.06 3.5 3.5 0 00-4.95 0l-2.5 2.5a3.5 3.5 0 004.95 4.95l1.25-1.25a.75.75 0 00-1.06-1.06l-1.25 1.25a2 2 0 01-2.83 0z'></path></svg>");
	mask-image: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' version='1.1' aria-hidden='true'><path fill-rule='evenodd' d='M7.775 3.275a.75.75 0 001.06 1.06l1.25-1.25a2 2 0 112.83 2.83l-2.5 2.5a2 2 0 01-2.83 0 .75.75 0 00-1.06 1.06 3.5 3.5 0 004.95 0l2.5-2.5a3.5 3.5 0 00-4.95-4.95l-1.25 1.25zm-4.69 9.64a2 2 0 010-2.83l2.5-2.5a2 2 0 012.83 0 .75.75 0 001.06-1.06 3.5 3.5 0 00-4.95 0l-2.5 2.5a3.5 3.5 0 004.95 4.95l1.25-1.25a.75.75 0 00-1.06-1.06l-1.25 1.25a2 2 0 01-2.83 0z'></path></svg>")
}

.markdown-body details, .markdown-body figcaption, .markdown-body figure {
	display: block
}

.markdown-body summary {
	display: list-item
}

.markdown-body [hidden] {
	display: none !important
}

.markdown-body a {
	background-color: transparent;
	color: var(--color-accent-fg);
	text-decoration: none
}

.markdown-body abbr[title] {
	border-bottom: none;
	text-decoration: underline dotted
}

.markdown-body b, .markdown-body strong {
	font-weight: var(--base-text-weight-semibold, 600)
}

.markdown-body dfn {
	font-style: italic
}

.markdown-body h1 {
	margin: .67em 0;
	font-weight: var(--base-text-weight-semibold, 600);
	padding-bottom: .3em;
	font-size: 2em;
	border-bottom: 1px solid var(--color-border-muted)
}

.markdown-body mark {
	background-color: var(--color-attention-subtle);
	color: var(--color-fg-default)
}

.markdown-body small {
	font-size: 90%
}

.markdown-body sub, .markdown-body sup {
	font-size: 75%;
	line-height: 0;
	position: relative;
	vertical-align: baseline
}

.markdown-body sub {
	bottom: -.25em
}

.markdown-body sup {
	top: -.5em
}

.markdown-body img {
	border-style: none;
	max-width: 100%;
	box-sizing: content-box;
	background-color: var(--color-canvas-default)
}

.markdown-body code, .markdown-body kbd, .markdown-body pre, .markdown-body samp {
	font-family: monospace;
	font-size: 1em
}

.markdown-body figure {
	margin: 1em 40px
}

.markdown-body hr {
	box-sizing: content-box;
	overflow: hidden;
	background: 0 0;
	border-bottom: 1px solid var(--color-border-muted);
	height: .25em;
	padding: 0;
	margin: 24px 0;
	background-color: var(--color-border-default);
	border: 0
}

.markdown-body input {
	font: inherit;
	margin: 0;
	overflow: visible;
	font-family: inherit;
	font-size: inherit;
	line-height: inherit
}

.markdown-body [type=button], .markdown-body [type=reset], .markdown-body [type=submit] {
	-webkit-appearance: button
}

.markdown-body [type=checkbox], .markdown-body [type=radio] {
	box-sizing: border-box;
	padding: 0
}

.markdown-body [type=number]::-webkit-inner-spin-button, .markdown-body [type=number]::-webkit-outer-spin-button {
	height: auto
}

.markdown-body [type=search]::-webkit-search-cancel-button, .markdown-body [type=search]::-webkit-search-decoration {
	-webkit-appearance: none
}

.markdown-body ::-webkit-input-placeholder {
	color: inherit;
	opacity: .54
}

.markdown-body ::-webkit-file-upload-button {
	-webkit-appearance: button;
	font: inherit
}

.markdown-body a:hover {
	text-decoration: underline
}

.markdown-body ::placeholder {
	color: var(--color-fg-subtle);
	opacity: 1
}

.markdown-body hr::before {
	display: table;
	content: ""
}

.markdown-body hr::after {
	display: table;
	clear: both;
	content: ""
}

.markdown-body table {
	border-spacing: 0;
	border-collapse: collapse;
	display: block;
	width: max-content;
	max-width: 100%;
	overflow: auto
}

.markdown-body td, .markdown-body th {
	padding: 0
}

.markdown-body details summary {
	cursor: pointer
}

.markdown-body details:not([open]) > :not(summary) {
	display: none !important
}

.markdown-body [role=button]:focus, .markdown-body a:focus, .markdown-body input[type=checkbox]:focus, .markdown-body input[type=radio]:focus {
	outline: 2px solid var(--color-accent-fg);
	outline-offset: -2px;
	box-shadow: none
}

.markdown-body [role=button]:focus:not(:focus-visible), .markdown-body a:focus:not(:focus-visible), .markdown-body input[type=checkbox]:focus:not(:focus-visible), .markdown-body input[type=radio]:focus:not(:focus-visible) {
	outline: solid 1px transparent
}

.markdown-body [role=button]:focus-visible, .markdown-body a:focus-visible, .markdown-body input[type=checkbox]:focus-visible, .markdown-body input[type=radio]:focus-visible {
	outline: 2px solid var(--color-accent-fg);
	outline-offset: -2px;
	box-shadow: none
}

.markdown-body a:not([class]):focus, .markdown-body a:not([class]):focus-visible, .markdown-body input[type=checkbox]:focus, .markdown-body input[type=checkbox]:focus-visible, .markdown-body input[type=radio]:focus, .markdown-body input[type=radio]:focus-visible {
	outline-offset: 0
}

.markdown-body kbd {
	display: inline-block;
	padding: 3px 5px;
	font: 11px ui-monospace, SFMono-Regular, SF Mono, Menlo, Consolas, Liberation Mono, monospace;
	line-height: 10px;
	color: var(--color-fg-default);
	vertical-align: middle;
	background-color: var(--color-canvas-subtle);
	border: solid 1px var(--color-neutral-muted);
	border-bottom-color: var(--color-neutral-muted);
	border-radius: 6px;
	box-shadow: inset 0 -1px 0 var(--color-neutral-muted)
}

.markdown-body h1, .markdown-body h2, .markdown-body h3, .markdown-body h4, .markdown-body h5, .markdown-body h6 {
	margin-top: 24px;
	margin-bottom: 16px;
	font-weight: var(--base-text-weight-semibold, 600);
	line-height: 1.25
}

.markdown-body h2 {
	font-weight: var(--base-text-weight-semibold, 600);
	padding-bottom: .3em;
	font-size: 1.5em;
	border-bottom: 1px solid var(--color-border-muted)
}

.markdown-body h3 {
	font-weight: var(--base-text-weight-semibold, 600);
	font-size: 1.25em
}

.markdown-body h4 {
	font-weight: var(--base-text-weight-semibold, 600);
	font-size: 1em
}

.markdown-body h5 {
	font-weight: var(--base-text-weight-semibold, 600);
	font-size: .875em
}

.markdown-body h6 {
	font-weight: var(--base-text-weight-semibold, 600);
	font-size: .85em;
	color: var(--color-fg-muted)
}

.markdown-body p {
	margin-top: 0;
	margin-bottom: 10px
}

.markdown-body blockquote {
	margin: 0;
	padding: 0 1em;
	color: var(--color-fg-muted);
	border-left: .25em solid var(--color-border-default)
}

.markdown-body ol, .markdown-body ul {
	margin-top: 0;
	margin-bottom: 0;
	padding-left: 2em
}

.markdown-body ol ol, .markdown-body ul ol {
	list-style-type: lower-roman
}

.markdown-body ol ol ol, .markdown-body ol ul ol, .markdown-body ul ol ol, .markdown-body ul ul ol {
	list-style-type: lower-alpha
}

.markdown-body dd {
	margin-left: 0
}

.markdown-body code, .markdown-body samp, .markdown-body tt {
	font-family: ui-monospace, SFMono-Regular, SF Mono, Menlo, Consolas, Liberation Mono, monospace;
	font-size: 12px
}

.markdown-body pre {
	margin-top: 0;
	margin-bottom: 0;
	font-family: ui-monospace, SFMono-Regular, SF Mono, Menlo, Consolas, Liberation Mono, monospace;
	font-size: 12px;
	word-wrap: normal
}

.markdown-body .octicon {
	display: inline-block;
	overflow: visible !important;
	vertical-align: text-bottom;
	fill: currentColor
}

.markdown-body input::-webkit-inner-spin-button, .markdown-body input::-webkit-outer-spin-button {
	margin: 0;
	-webkit-appearance: none;
	appearance: none
}

.markdown-body::before {
	display: table;
	content: ""
}

.markdown-body::after {
	display: table;
	clear: both;
	content: ""
}

.markdown-body > :first-child {
	margin-top: 0 !important
}

.markdown-body > :last-child {
	margin-bottom: 0 !important
}

.markdown-body a:not([href]) {
	color: inherit;
	text-decoration: none
}

.markdown-body .absent {
	color: var(--color-danger-fg)
}

.markdown-body .anchor {
	float: left;
	padding-right: 4px;
	margin-left: -20px;
	line-height: 1
}

.markdown-body .anchor:focus {
	outline: 0
}

.markdown-body blockquote, .markdown-body details, .markdown-body dl, .markdown-body ol, .markdown-body p, .markdown-body pre, .markdown-body table, .markdown-body ul {
	margin-top: 0;
	margin-bottom: 16px
}

.markdown-body blockquote > :first-child {
	margin-top: 0
}

.markdown-body blockquote > :last-child {
	margin-bottom: 0
}

.markdown-body h1 .octicon-link, .markdown-body h2 .octicon-link, .markdown-body h3 .octicon-link, .markdown-body h4 .octicon-link, .markdown-body h5 .octicon-link, .markdown-body h6 .octicon-link {
	color: var(--color-fg-default);
	vertical-align: middle;
	visibility: hidden
}

.markdown-body h1:hover .anchor, .markdown-body h2:hover .anchor, .markdown-body h3:hover .anchor, .markdown-body h4:hover .anchor, .markdown-body h5:hover .anchor, .markdown-body h6:hover .anchor {
	text-decoration: none
}

.markdown-body h1:hover .anchor .octicon-link, .markdown-body h2:hover .anchor .octicon-link, .markdown-body h3:hover .anchor .octicon-link, .markdown-body h4:hover .anchor .octicon-link, .markdown-body h5:hover .anchor .octicon-link, .markdown-body h6:hover .anchor .octicon-link {
	visibility: visible
}

.markdown-body h1 code, .markdown-body h1 tt, .markdown-body h2 code, .markdown-body h2 tt, .markdown-body h3 code, .markdown-body h3 tt, .markdown-body h4 code, .markdown-body h4 tt, .markdown-body h5 code, .markdown-body h5 tt, .markdown-body h6 code, .markdown-body h6 tt {
	padding: 0 .2em;
	font-size: inherit
}

.markdown-body summary h1, .markdown-body summary h2, .markdown-body summary h3, .markdown-body summary h4, .markdown-body summary h5, .markdown-body summary h6 {
	display: inline-block
}

.markdown-body summary h1 .anchor, .markdown-body summary h2 .anchor, .markdown-body summary h3 .anchor, .markdown-body summary h4 .anchor, .markdown-body summary h5 .anchor, .markdown-body summary h6 .anchor {
	margin-left: -40px
}

.markdown-body summary h1, .markdown-body summary h2 {
	padding-bottom: 0;
	border-bottom: 0
}

.markdown-body ol.no-list, .markdown-body ul.no-list {
	padding: 0;
	list-style-type: none
}

.markdown-body ol[type=a] {
	list-style-type: lower-alpha
}

.markdown-body ol[type=A] {
	list-style-type: upper-alpha
}

.markdown-body ol[type=i] {
	list-style-type: lower-roman
}

.markdown-body ol[type=I] {
	list-style-type: upper-roman
}

.markdown-body ol[type="1"] {
	list-style-type: decimal
}

.markdown-body div > ol:not([type]) {
	list-style-type: decimal
}

.markdown-body ol ol, .markdown-body ol ul, .markdown-body ul ol, .markdown-body ul ul {
	margin-top: 0;
	margin-bottom: 0
}

.markdown-body li > p {
	margin-top: 16px
}

.markdown-body li + li {
	margin-top: .25em
}

.markdown-body dl {
	padding: 0
}

.markdown-body dl dt {
	padding: 0;
	margin-top: 16px;
	font-size: 1em;
	font-style: italic;
	font-weight: var(--base-text-weight-semibold, 600)
}

.markdown-body dl dd {
	padding: 0 16px;
	margin-bottom: 16px
}

.markdown-body table th {
	font-weight: var(--base-text-weight-semibold, 600)
}

.markdown-body table td, .markdown-body table th {
	padding: 6px 13px;
	border: 1px solid var(--color-border-default)
}

.markdown-body table tr {
	background-color: var(--color-canvas-default);
	border-top: 1px solid var(--color-border-muted)
}

.markdown-body table tr:nth-child(2n) {
	background-color: var(--color-canvas-subtle)
}

.markdown-body table img {
	background-color: transparent
}

.markdown-body img[align=right] {
	padding-left: 20px
}

.markdown-body img[align=left] {
	padding-right: 20px
}

.markdown-body .emoji {
	max-width: none;
	vertical-align: text-top;
	background-color: transparent
}

.markdown-body span.frame {
	display: block;
	overflow: hidden
}

.markdown-body span.frame > span {
	display: block;
	float: left;
	width: auto;
	padding: 7px;
	margin: 13px 0 0;
	overflow: hidden;
	border: 1px solid var(--color-border-default)
}

.markdown-body span.frame span img {
	display: block;
	float: left
}

.markdown-body span.frame span span {
	display: block;
	padding: 5px 0 0;
	clear: both;
	color: var(--color-fg-default)
}

.markdown-body span.align-center {
	display: block;
	overflow: hidden;
	clear: both
}

.markdown-body span.align-center > span {
	display: block;
	margin: 13px auto 0;
	overflow: hidden;
	text-align: center
}

.markdown-body span.align-center span img {
	margin: 0 auto;
	text-align: center
}

.markdown-body span.align-right {
	display: block;
	overflow: hidden;
	clear: both
}

.markdown-body span.align-right > span {
	display: block;
	margin: 13px 0 0;
	overflow: hidden;
	text-align: right
}

.markdown-body span.align-right span img {
	margin: 0;
	text-align: right
}

.markdown-body span.float-left {
	display: block;
	float: left;
	margin-right: 13px;
	overflow: hidden
}

.markdown-body span.float-left span {
	margin: 13px 0 0
}

.markdown-body span.float-right {
	display: block;
	float: right;
	margin-left: 13px;
	overflow: hidden
}

.markdown-body span.float-right > span {
	display: block;
	margin: 13px auto 0;
	overflow: hidden;
	text-align: right
}

.markdown-body code, .markdown-body tt {
	padding: .2em .4em;
	margin: 0;
	font-size: 85%;
	white-space: break-spaces;
	background-color: var(--color-neutral-muted);
	border-radius: 6px
}

.markdown-body code br, .markdown-body tt br {
	display: none
}

.markdown-body del code {
	text-decoration: inherit
}

.markdown-body samp {
	font-size: 85%
}

.markdown-body pre code {
	font-size: 100%
}

.markdown-body pre > code {
	padding: 0;
	margin: 0;
	word-break: normal;
	white-space: pre;
	background: 0 0;
	border: 0
}

.markdown-body .highlight {
	margin-bottom: 16px
}

.markdown-body .highlight pre {
	margin-bottom: 0;
	word-break: normal
}

.markdown-body .highlight pre, .markdown-body pre {
	padding: 16px;
	overflow: auto;
	font-size: 85%;
	line-height: 1.45;
	background-color: var(--color-canvas-subtle);
	border-radius: 6px
}

.markdown-body pre code, .markdown-body pre tt {
	display: inline;
	max-width: auto;
	padding: 0;
	margin: 0;
	overflow: visible;
	line-height: inherit;
	word-wrap: normal;
	background-color: transparent;
	border: 0
}

.markdown-body .csv-data td, .markdown-body .csv-data th {
	padding: 5px;
	overflow: hidden;
	font-size: 12px;
	line-height: 1;
	text-align: left;
	white-space: nowrap
}

.markdown-body .csv-data .blob-num {
	padding: 10px 8px 9px;
	text-align: right;
	background: var(--color-canvas-default);
	border: 0
}

.markdown-body .csv-data tr {
	border-top: 0
}

.markdown-body .csv-data th {
	font-weight: var(--base-text-weight-semibold, 600);
	background: var(--color-canvas-subtle);
	border-top: 0
}

.markdown-body [data-footnote-ref]::before {
	content: "["
}

.markdown-body [data-footnote-ref]::after {
	content: "]"
}

.markdown-body .footnotes {
	font-size: 12px;
	color: var(--color-fg-muted);
	border-top: 1px solid var(--color-border-default)
}

.markdown-body .footnotes ol {
	padding-left: 16px
}

.markdown-body .footnotes ol ul {
	display: inline-block;
	padding-left: 16px;
	margin-top: 16px
}

.markdown-body .footnotes li {
	position: relative
}

.markdown-body .footnotes li:target::before {
	position: absolute;
	top: -8px;
	right: -8px;
	bottom: -8px;
	left: -24px;
	pointer-events: none;
	content: "";
	border: 2px solid var(--color-accent-emphasis);
	border-radius: 6px
}

.markdown-body .footnotes li:target {
	color: var(--color-fg-default)
}

.markdown-body .footnotes .data-footnote-backref g-emoji {
	font-family: monospace
}

.markdown-body .pl-c {
	color: var(--color-prettylights-syntax-comment)
}

.markdown-body .pl-c1, .markdown-body .pl-s .pl-v {
	color: var(--color-prettylights-syntax-constant)
}

.markdown-body .pl-e, .markdown-body .pl-en {
	color: var(--color-prettylights-syntax-entity)
}

.markdown-body .pl-s .pl-s1, .markdown-body .pl-smi {
	color: var(--color-prettylights-syntax-storage-modifier-import)
}

.markdown-body .pl-ent {
	color: var(--color-prettylights-syntax-entity-tag)
}

.markdown-body .pl-k {
	color: var(--color-prettylights-syntax-keyword)
}

.markdown-body .pl-pds, .markdown-body .pl-s, .markdown-body .pl-s .pl-pse .pl-s1, .markdown-body .pl-sr, .markdown-body .pl-sr .pl-cce, .markdown-body .pl-sr .pl-sra, .markdown-body .pl-sr .pl-sre {
	color: var(--color-prettylights-syntax-string)
}

.markdown-body .pl-smw, .markdown-body .pl-v {
	color: var(--color-prettylights-syntax-variable)
}

.markdown-body .pl-bu {
	color: var(--color-prettylights-syntax-brackethighlighter-unmatched)
}

.markdown-body .pl-ii {
	color: var(--color-prettylights-syntax-invalid-illegal-text);
	background-color: var(--color-prettylights-syntax-invalid-illegal-bg)
}

.markdown-body .pl-c2 {
	color: var(--color-prettylights-syntax-carriage-return-text);
	background-color: var(--color-prettylights-syntax-carriage-return-bg)
}

.markdown-body .pl-sr .pl-cce {
	font-weight: 700;
	color: var(--color-prettylights-syntax-string-regexp)
}

.markdown-body .pl-ml {
	color: var(--color-prettylights-syntax-markup-list)
}

.markdown-body .pl-mh, .markdown-body .pl-mh .pl-en, .markdown-body .pl-ms {
	font-weight: 700;
	color: var(--color-prettylights-syntax-markup-heading)
}

.markdown-body .pl-mi {
	font-style: italic;
	color: var(--color-prettylights-syntax-markup-italic)
}

.markdown-body .pl-mb {
	font-weight: 700;
	color: var(--color-prettylights-syntax-markup-bold)
}

.markdown-body .pl-md {
	color: var(--color-prettylights-syntax-markup-deleted-text);
	background-color: var(--color-prettylights-syntax-markup-deleted-bg)
}

.markdown-body .pl-mi1 {
	color: var(--color-prettylights-syntax-markup-inserted-text);
	background-color: var(--color-prettylights-syntax-markup-inserted-bg)
}

.markdown-body .pl-mc {
	color: var(--color-prettylights-syntax-markup-changed-text);
	background-color: var(--color-prettylights-syntax-markup-changed-bg)
}

.markdown-body .pl-mi2 {
	color: var(--color-prettylights-syntax-markup-ignored-text);
	background-color: var(--color-prettylights-syntax-markup-ignored-bg)
}

.markdown-body .pl-mdr {
	font-weight: 700;
	color: var(--color-prettylights-syntax-meta-diff-range)
}

.markdown-body .pl-ba {
	color: var(--color-prettylights-syntax-brackethighlighter-angle)
}

.markdown-body .pl-sg {
	color: var(--color-prettylights-syntax-sublimelinter-gutter-mark)
}

.markdown-body .pl-corl {
	text-decoration: underline;
	color: var(--color-prettylights-syntax-constant-other-reference-link)
}

.markdown-body g-emoji {
	display: inline-block;
	min-width: 1ch;
	font-family: "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
	font-size: 1em;
	font-style: normal !important;
	font-weight: var(--base-text-weight-normal, 400);
	line-height: 1;
	vertical-align: -.075em
}

.markdown-body g-emoji img {
	width: 1em;
	height: 1em
}

.markdown-body .task-list-item {
	list-style-type: none
}

.markdown-body .task-list-item label {
	font-weight: var(--base-text-weight-normal, 400)
}

.markdown-body .task-list-item.enabled label {
	cursor: pointer
}

.markdown-body .task-list-item + .task-list-item {
	margin-top: 4px
}

.markdown-body .task-list-item .handle {
	display: none
}

.markdown-body .task-list-item-checkbox {
	margin: 0 .2em .25em -1.4em;
	vertical-align: middle
}

.markdown-body .contains-task-list:dir(rtl) .task-list-item-checkbox {
	margin: 0 -1.6em .25em .2em
}

.markdown-body .contains-task-list {
	position: relative
}

.markdown-body .contains-task-list:focus-within .task-list-item-convert-container, .markdown-body .contains-task-list:hover .task-list-item-convert-container {
	display: block;
	width: auto;
	height: 24px;
	overflow: visible;
	clip: auto
}

.markdown-body ::-webkit-calendar-picker-indicator {
	filter: invert(50%)
}

</style>




// WEBPACK FOOTER //
// src/containers/PrivacyAgreement/SdkPrivacyAgreement.vue